import React from "react";
import { Card } from "react-bootstrap";

const TabelRekap = ({ data = [], startIndex = 0, handleDetailClick = () => { }, setFilterText = () => { } }) => {
    if (!Array.isArray(data) || data.length === 0) {
        return <p className="text-muted">Data belum tersedia.</p>;
    }

    const getKode = (label) => {
        switch (label) {
            case "CPPIB": return "032000000014";
            case "CPIB": return "032000000034";
            case "CPOIB": return "032000000019";
            case "CBIB Kapal": return "032000000033";
            case "CDOIB": return "032000000036";
            case "CBIB": return "032000000068";
            default: return null;
        }
    };

    return (
        <table className="table table-sm table-striped table-bordered small">
            <thead className="table-light">
                <tr>
                    <th style={{ width: "30px" }} className="text-center align-middle">#</th>
                    <th className="text-nowrap align-middle">Provinsi</th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>CPPIB</th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>CPIB</th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>CPOIB</th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>
                        CBIB<br />Kapal
                    </th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>CDOIB</th>
                    <th className="text-center align-middle" style={{ width: "60px" }}>CBIB</th>
                    <th className="text-center align-middle fw-bold" style={{ width: "60px" }}>JUMLAH</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, i) => (
                    <tr key={i}>
                        <td className="text-center">{startIndex + i}</td>
                        <td className="text-nowrap">{item.propinsi}</td>
                        {['CPPIB', 'CPIB', 'CPOIB', 'CBIB Kapal', 'CDOIB', 'CBIB', 'JUMLAH'].map((field, idx) => (
                            <td key={idx} className={`text-end text-nowrap${field === 'JUMLAH' ? ' fw-bold' : ''}`}>
                                {item[field] > 0 ? (
                                    <a
                                        href="#"
                                        className="text-decoration-none fw-bold text-primary"
                                        onClick={(e) => {
                                            e.preventDefault();
                                            {field === 'JUMLAH' ? setFilterText(`Sertifikasi Primer Provinsi ${item.propinsi}`) : setFilterText(`${field} Provinsi ${item.propinsi}`)}
                                            handleDetailClick(getKode(field), item.kode_propinsi);
                                        }}
                                    >
                                        {item[field]}
                                    </a>
                                ) : item[field]}
                            </td>
                        ))}
                    </tr>
                ))}
            </tbody>
        </table>
    );
};

export default TabelRekap;
